export const getSelectionOptionsFromEnum = <T extends Record<string, any>>(arg: T) => {
  return Object.keys(arg).map((option) => ({
    value: arg[option as keyof T],
    label: option,
  }));
};
